import {
  KeyRound,
  Eye,
  Hammer,
  Trees,
  HeartHandshake,
  Building2,
  ArrowUpRight,
} from "lucide-react";

const SERVICE_IMG =
  "https://images.pexels.com/photos/31985444/pexels-photo-31985444.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";

const SERVICES = [
  {
    num: "01",
    icon: KeyRound,
    title: "Immobilienvermittlung",
    desc: "Kauf, Verkauf und Vermietung in Südhessen — fair, transparent und ohne leere Versprechen.",
    featured: true,
  },
  {
    num: "02",
    icon: Eye,
    title: "Besichtigungen & Verkaufsunterstützung",
    desc: "Sie verkaufen selbst, brauchen aber Unterstützung? Ich übernehme Besichtigungen und Verkaufshilfe — auch ohne klassische Maklerprovision.",
  },
  {
    num: "03",
    icon: Hammer,
    title: "Instandhaltung & Reparaturen",
    desc: "Kleine Reparaturen, regelmäßige Instandhaltung — ich packe selbst mit an, statt nur zu vermitteln.",
  },
  {
    num: "04",
    icon: Trees,
    title: "Pflege & Gartenarbeit",
    desc: "Damit Ihre Immobilie gepflegt bleibt — innen wie außen. Garten, Außenanlagen, regelmäßige Pflege.",
  },
  {
    num: "05",
    icon: Building2,
    title: "Objektbetreuung",
    desc: "Kein klassischer Hausmeisterdienst, sondern echte Betreuung Ihrer Immobilie mit Auge fürs Detail.",
  },
  {
    num: "06",
    icon: HeartHandshake,
    title: "Persönliche Begleitung",
    desc: "Vom ersten Gespräch bis lange nach der Schlüsselübergabe — ich bleibe Ihr Ansprechpartner.",
  },
];

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="bg-[#F5F5F5] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 lg:mb-20">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#8A151B]" />
              <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
                Leistungen
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0A0A0A] leading-[1.05]">
              Alles rund ums Haus.
              <br />
              <span className="text-neutral-400">Eine Hand. Ein Wort.</span>
            </h2>
          </div>
          <p className="text-base text-neutral-600 max-w-md lg:text-right">
            Sechs Leistungen — flexibel kombinierbar. Sie entscheiden,
            wie viel oder wie wenig Sie brauchen.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-300 border border-neutral-300">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const featured = s.featured;
            return (
              <a
                key={s.num}
                href="#kontakt"
                data-testid={`service-card-${i}`}
                className={`group relative bg-white p-8 lg:p-10 hover:bg-[#0A0A0A] transition-all duration-500 ${
                  featured ? "md:col-span-2 lg:row-span-2" : ""
                }`}
              >
                <div className="flex flex-col h-full min-h-[280px]">
                  <div className="flex items-start justify-between mb-8">
                    <span className="font-display text-sm font-bold tracking-widest text-neutral-400 group-hover:text-[#8A151B] transition-colors">
                      {s.num}
                    </span>
                    <ArrowUpRight
                      size={20}
                      className="text-neutral-400 group-hover:text-[#8A151B] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                    />
                  </div>

                  <div className="mb-6">
                    <Icon
                      size={featured ? 56 : 40}
                      strokeWidth={1.25}
                      className="text-[#0A0A0A] group-hover:text-[#8A151B] transition-colors"
                    />
                  </div>

                  <h3
                    className={`font-display font-bold tracking-tight text-[#0A0A0A] group-hover:text-white transition-colors mb-3 ${
                      featured ? "text-3xl lg:text-4xl" : "text-xl lg:text-2xl"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`text-neutral-600 group-hover:text-neutral-300 transition-colors leading-relaxed ${
                      featured ? "text-base lg:text-lg max-w-md" : "text-sm"
                    }`}
                  >
                    {s.desc}
                  </p>

                  {featured && (
                    <div className="mt-auto pt-8">
                      <img
                        src={SERVICE_IMG}
                        alt="Südhessen Häuser"
                        className="w-full h-64 lg:h-72 object-cover object-center grayscale group-hover:grayscale-0 transition-all duration-700"
                      />
                    </div>
                  )}
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
